import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { SERVER_URL } from "../initalState";

export const dashboardSlice = createApi({
  reducerPath: "dashboard",
  baseQuery: fetchBaseQuery({
    baseUrl: SERVER_URL + "/qiktrack",
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    company_dashboard: builder.query({
      query: ({ days,company_id }) => {
        // Create params object, only including non-empty values
        const params = {};
        if (days !== undefined && days !== "") params.days = days;
        if (company_id !== undefined && company_id !== "")
          params.company_id = company_id;
        console.log(params);
        return {
          url: `/company-dashboard`,
          method: "GET",
          params: Object.keys(params).length > 0 ? params : undefined,
        };
      },
      providesTags: ["driver"], // Tag for cache invalidation
      keepUnusedDataFor: 0, // Add this to match get_bank_account behavior
    }),

        get_company: builder.query({
      query: ({ days,company_id }) => {
        // Create params object, only including non-empty values
        const params = {};
        if (days !== undefined && days !== "") params.days = days;
        if (company_id !== undefined && company_id !== "")
          params.company_id = company_id;
        console.log(params);
        return {
          url: `/get-company`,
          method: "GET",
          params: Object.keys(params).length > 0 ? params : undefined,
        };
      },
      providesTags: ["driver"], // Tag for cache invalidation
      keepUnusedDataFor: 0, // Add this to match get_bank_account behavior
    }),
  }),
});

export const { useCompany_dashboardQuery ,useGet_companyQuery} = dashboardSlice;
